export const  ModalAlertPointerPosition = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right',
}

export const ModalAlertOffsets = {
    [ModalAlertPointerPosition.LEFT]: {
        left: -50,
        top: 20,
    },
    [ModalAlertPointerPosition.CENTER]: {
        left: 0,
        top: 20,
    },
    [ModalAlertPointerPosition.RIGHT]: {
        left: 50,
        top: 20,
    },
}



// WEBPACK FOOTER //
// ./web/js/components/modalAlert/constants.js